import { DATE_TIME_FORMAT, DATE_FORMAT } from '../../config/locale';

import { tzNormalizeDate } from '../date';
import { numberFormatter } from '../number';

import {
  addQrCode,
  addText,
  createPdfDocument,
  paragraphSize,
  setFont,
  y,
} from '../pdf';

import { convertNumberToText, padStart } from '../string';

const myX = 3;
let myY = y;
const margin = 3;

const qrWidth = 35;
const qrHeight = 35;

const printLine = (doc) => {
  addText(
    doc,
    '----------------------------------------------------------------------------',
    40,
    (myY += margin),
    80,
  );
};

const printCompanyFields = (doc) => {
  setFont(doc, 'bold');
  doc.setFontSize(paragraphSize);

  addText(doc, 'TURISMO CIVA S.A.C.', 40, myY, 80);

  setFont(doc);

  addText(doc, 'Si va de viaje, ¡viaje en Civa!', 40, (myY += margin), 80);

  addText(doc, 'R.U.C 20102427891', 40, (myY += margin), 80);

  addText(doc, 'JR SANCHO DE RIVERA 1184', 40, (myY += margin), 80);

  addText(doc, 'URB. MONSERRATE LIMA', 40, (myY += margin), 80);

  addText(doc, 'Central Telefónica: (511) 418-1111', 40, (myY += margin), 80);

  printLine(doc);
};

const printDebitNoteFields = (
  doc,
  { issuingAgency, createDate, debitNoteCode },
) => {
  const agencyNameText = doc.splitTextToSize(
    `Agencia de Emisión: ${issuingAgency}`,
    75,
  );

  agencyNameText.forEach((text) => {
    addText(doc, text, myX, (myY += margin), 75, 'left');
  });

  addText(
    doc,
    `Fecha/Hora Emisión: ${createDate}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  setFont(doc, 'bold');
  doc.setFontSize(14);

  const voucherText = doc.splitTextToSize('NOTA DE DEBITO ELECTRONICA', 75);

  voucherText.forEach((text) => {
    addText(doc, text, 40, (myY += 5), 75);
  });

  addText(doc, debitNoteCode, 40, (myY += 5), 75);

  doc.setFontSize(paragraphSize);

  setFont(doc);

  printLine(doc);
};

const printModifiedDocument = (
  doc,
  {
    voucherType,
    createDate,
    documentCode,
    companyDocumentNumber,
    companyName,
    fullName,
    identificationType,
    idDocumentNumber,
    motive,
    pin,
  },
) => {
  setFont(doc, 'bold');

  addText(doc, 'DOCUMENTO QUE MODIFICA:', myX, (myY += margin * 2), 50, 'left');

  setFont(doc);

  addText(
    doc,
    `${voucherType.toUpperCase()}: ${documentCode}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  addText(doc, `FECHA: ${createDate}`, myX, (myY += margin), 75, 'left');

  const documentTypeText = companyDocumentNumber ? 'RUC' : identificationType;

  const documentTypeValue = companyDocumentNumber || idDocumentNumber;

  addText(
    doc,
    `${documentTypeText || '-'}: ${documentTypeValue || '-'}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  const companyNameValue = companyName || fullName || '-';

  const companyNameText = doc.splitTextToSize(
    `SEÑOR(ES): ${companyNameValue}`,
    75,
  );

  companyNameText.forEach((text) => {
    addText(doc, text, myX, (myY += margin), 75, 'left');
  });

  addText(doc, 'TIPO DE MONEDA: SOLES', myX, (myY += margin), 75, 'left');

  if (motive) {
    const motiveText = doc.splitTextToSize(
      `SUSTENTO: ${motive.toUpperCase()}`,
      75,
    );

    motiveText.forEach((text) => {
      addText(doc, text, myX, (myY += margin), 75, 'left');
    });
  }

  if (pin) {
    addText(doc, `PIN: ${pin}`, myX, (myY += margin), 75, 'left');
  }

  printLine(doc);
};

const printPaymentFields = (
  doc,
  { amount, amountString, paymentMethod, userName, expirationDate },
) => {
  setFont(doc, 'bold');

  addText(doc, 'DATOS DE PAGO:', myX, (myY += margin * 2), 75, 'left');

  setFont(doc);

  addText(doc, 'OP. GRAVADA', myX, (myY += margin), 75, 'left');

  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);

  addText(doc, 'OP. GRATUITO', myX, (myY += margin), 75, 'left');

  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);

  addText(doc, 'OP. EXONERADO', myX, (myY += margin), 75, 'left');

  addText(doc, `: ${numberFormatter({ value: amount })}`, myX + 34, myY);

  addText(doc, 'OP. INAFECTO', myX, (myY += margin), 75, 'left');

  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);

  addText(doc, 'IGV', myX, (myY += margin), 75, 'left');

  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);

  addText(doc, 'IMPORTE TOTAL', myX, (myY += margin), 75, 'left');

  addText(doc, `: ${numberFormatter({ value: amount })}`, myX + 34, myY);

  addText(doc, 'Son:', myX, (myY += margin), 10, 'left');

  const amountStringText = doc.splitTextToSize(amountString, 75);

  amountStringText.forEach((text, index) => {
    addText(doc, text, myX + 6, (myY += index === 0 ? 0 : margin), 75, 'left');
  });

  addText(doc, 'Tipo de Pago', myX, (myY += margin), 75, 'left');

  addText(doc, ':', myX + 34, myY);

  const paymentMethodText = doc.splitTextToSize(paymentMethod || '-', 40);

  paymentMethodText.forEach((text, index) => {
    addText(doc, text, myX + 36, (myY += index === 0 ? 0 : margin), 40, 'left');
  });

  addText(doc, 'Numero Tarjeta', myX, (myY += margin), 75, 'left');

  addText(doc, ': -', myX + 34, myY);

  addText(doc, 'Numero Voucher', myX, (myY += margin), 75, 'left');

  addText(doc, ': -', myX + 34, myY);

  addText(doc, 'Usuario', myX, (myY += margin), 75, 'left');

  addText(doc, ':', myX + 34, myY);

  const userNameText = doc.splitTextToSize(userName || '-', 40);

  userNameText.forEach((text, index) => {
    addText(doc, text, myX + 36, (myY += index === 0 ? 0 : margin), 40, 'left');
  });

  if (expirationDate) {
    addText(
      doc,
      `Fecha de vencimiento: ${expirationDate}`,
      myX,
      (myY += margin * 2),
      75,
      'left',
    );
  }

  addText(
    doc,
    'Representación impresa de la Nota de Débito',
    40,
    (myY += margin * 2),
    74,
    'center',
  );
};

const getLatestTransaction = (parcel) => {
  if (parcel.transactionList && parcel.transactionList.length > 0) {
    const sorted = Array.from(parcel.transactionList)
      .slice()
      .sort((a, b) => b.id - a.id);

    return sorted[0];
  }

  return null;
};

const formatCargoDebitNote = (parcel, debitNote) => {
  const transaction = getLatestTransaction(parcel);

  const voucherPrefix =
    parcel.business || (transaction && transaction.business) ? 'F' : 'B';

  const originalDocumentCode = `${parcel.documentSeries}-${padStart(
    parcel.documentCode,
    7,
  )}`;

  const debitNoteCode = `${voucherPrefix}${debitNote.documentSeries}-${padStart(
    debitNote.documentCode,
    7,
  )}`;

  const debitNoteCreateDate = debitNote.createDate
    ? tzNormalizeDate({
        date: debitNote.createDate,
        format: DATE_TIME_FORMAT,
      })
    : '-';

  const expirationDate = debitNote.expirationDate
    ? tzNormalizeDate({
        date: debitNote.expirationDate,
        format: DATE_FORMAT,
      })
    : null;

  const originalDocumentDate = parcel.createDate
    ? tzNormalizeDate({
        date: parcel.createDate,
        format: DATE_TIME_FORMAT,
      })
    : '-';

  const companyDocumentNumber =
    debitNote.businessTaxId ||
    (parcel.business ? parcel.business.businessTaxId : undefined);

  const companyName =
    debitNote.businessName ||
    (parcel.business ? parcel.business.name : undefined);

  const fullName =
    debitNote.customerFullName ||
    (parcel.customer ? parcel.customer.fullName : undefined);

  const identificationType =
    parcel.customer && parcel.customer.identificationType
      ? parcel.customer.identificationType.name
      : null;

  const idDocumentNumber =
    debitNote.customerIdDocumentNumber ||
    (parcel.customer ? parcel.customer.idDocumentNumber : undefined);

  const paymentMethod =
    debitNote.paymentMethodName ||
    (transaction ? transaction.paymentMethodName : parcel.paymentMethodName);

  const motive =
    debitNote.motiveDescription ||
    debitNote.motive ||
    debitNote.description ||
    null;

  return {
    debitNoteFields: {
      issuingAgency: `${parcel.agency.name}\n${parcel.agency.address}`,
      createDate: debitNoteCreateDate,
      debitNoteCode,
    },

    modifiedDocumentFields: {
      voucherType:
        parcel.voucherTypeName ||
        (transaction && transaction.voucherType
          ? transaction.voucherType.name
          : 'Comprobante'),

      createDate: originalDocumentDate,

      documentCode: originalDocumentCode,

      companyDocumentNumber,

      companyName,

      fullName,

      identificationType,

      idDocumentNumber,

      motive,

      pin: debitNote.reference,
    },

    paymentFields: {
      amount: debitNote.amount,

      amountString: convertNumberToText(debitNote.amount, true),

      paymentMethod,

      userName:
        parcel.user && parcel.user.customer
          ? parcel.user.customer.fullName
          : '-',

      expirationDate,
    },
  };
};

const addDebitNote = async (
  doc,
  { debitNoteFields, modifiedDocumentFields, paymentFields },
) => {
  await addQrCode(
    doc,
    debitNoteFields.debitNoteCode,
    22.5,
    0,
    qrWidth,
    qrHeight,
  );

  myY += 32;

  printCompanyFields(doc);

  printDebitNoteFields(doc, debitNoteFields);

  printModifiedDocument(doc, modifiedDocumentFields);

  printPaymentFields(doc, paymentFields);

  myY = 5;
};

const printParcelDebitNote = async (parcel) => {
  const debitNotes = (parcel.debitNoteList || [])
    .filter((debitNote) => debitNote.valid !== false)
    .slice()
    .sort((a, b) => {
      if (a.createDate && b.createDate) {
        return new Date(a.createDate) - new Date(b.createDate);
      }

      return (a.id || 0) - (b.id || 0);
    });

  if (debitNotes.length === 0) {
    return;
  }

  const doc = createPdfDocument('p', 'mm', [80, 230]);

  for (let i = 0; i < debitNotes.length; i += 1) {
    const debitNote = debitNotes[i];

    const formatted = formatCargoDebitNote(parcel, debitNote);

    myY = 5;

    // eslint-disable-next-line no-await-in-loop
    await addDebitNote(doc, formatted);

    if (i < debitNotes.length - 1) {
      doc.addPage([80, 230], 'p');

      myY = 5;
    }
  }

  doc.autoPrint();

  window.open(doc.output('bloburl'), '_blank');
};

export default printParcelDebitNote;
